import React from 'react'

const PageHeader = ({ label, className }) => <div className={` text-black text-center text-40 sm:text-2xl ${className}`}>{label}</div>

export default PageHeader
